<template>
  <div class="forbidden" style="padding: 100px 40px; margin: 0 auto; text-align: center">
    <Heading level="h2">{{ $t("forbiddenPage.title") }}</Heading>
    <Paragraph>{{ $t("forbiddenPage.content") }}</Paragraph>
  </div>
</template>

<script lang="ts">
import Heading from "@/design-system/elements/Heading.vue";
import Paragraph from "@/design-system/elements/Paragraph.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Forbidden",
  components: {
    Heading,
    Paragraph,
  },
});
</script>
